import { motion } from "framer-motion";

export default function Projects() {
  const projects = [
    {
      title: "AI Chat Platform",
      desc: "React + Python + OpenAI integration",
    },
    {
      title: "Cloud Automation Tool",
      desc: "AWS + FastAPI + Docker",
    },
    {
      title: "Portfolio Generator",
      desc: "Dynamic React resume builder",
    },
  ];

  return (
    <section id="projects">
      <h2 style={{ fontSize: 36 }}>Projects</h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 25,
          marginTop: 40,
        }}
      >
        {projects.map((p, i) => (
          <motion.div
            key={i}
            whileHover={{ scale: 1.05 }}
            className="glass"
            style={{
              padding: 25,
              cursor: "pointer",
            }}
          >
            <h3>{p.title}</h3>
            <p style={{ color: "#9ca3af" }}>{p.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}